<template> 
             <div>
        <b-modal id="noticemodel"
                 size="lg"
                 title="BootstrapVue"
                 class="modal-backdrop"
                 no-close-on-esc
                 no-close-on-backdrop                 
                 >
            <template slot="modal-header">
                <h5 class="modal-title">Notice</h5>
            </template>
            <template slot="default">
                <p>Starting {{startingDate}} Case permissions will be separated into two categories "Cases" and "Case Functionality". Going forward, to grant permissions for a user to manage cases, at least one option must be checked under the "Cases" permissions options. </p>

                <div class="mt-2 py-4 float-left">
                    <img src="@/assets/img/CaseFunctionality.png" style="width: 47rem; height: 6.5rem;"/>
                </div>             
            </template>
            <template v-slot:modal-footer="{ ok  }">              
              <div><input type="checkbox" id="doNotShowCheckbox" class="form-check-input" value ="true" v-model="doNotShowCheckbox" /> 
                <label> Do not show this again </label></div>  
               <div><b-button class="um-btn"  @click="submitUserPreferenceForNotice()" >Continue</b-button></div>     
             </template>
        </b-modal>
    </div>   
</template>

<script>

import enviromentVariable from '../../constants/enviromentVariable';

    export default {
        name: "NoticeModel",       
        data() {
            return {    
                isLoading: false,
                startingDate : enviromentVariable.noticeToEndUserStartingDate,
                Duration: enviromentVariable.isInvalidDateForNotice,
                doNotShowCheckbox:false,
                userInfo: this.userDetail
            };
        },
        methods : 
        {
            submitUserPreferenceForNotice(){
              
                var loggedinUsername =  this.$store.getters.username

                if(this.doNotShowCheckbox){    
                    let currentDate = new Date();
                    currentDate.setMonth(currentDate.getMonth() + 3);                                        
                    document.cookie = 'DoNotShowAgainFor'+loggedinUsername+'Confirmed=true; expires='+ currentDate.toUTCString();                  
                }
                  this.$bvModal.hide("noticemodel");
            }
        }
    }
</script>

